export default __webpack_public_path__ + "static/ai-marketing-7-8c7f503bdaf168a91a5fce680e4db7ff.jpg";